import logo from '../Logo.png';
import logoEvent from 'src/assets/images/event/desktopLogoEvent.webp';

export const Logo = ({ className }: { className?: string }) => {
  const isEventActive = false;

  return <img src={isEventActive ? logoEvent : logo} className={className} alt="logo" />;
};
